<template>
  <el-form class="resetPasswordForm"
    label-position="right"
    label-width="100px"
    :model="form"
    :rules="rules"
    ref="form">
    <el-form-item label="手机号码">
      <p>{{userPhone}}</p>
    </el-form-item>
    <el-form-item label="短信验证码"
      prop="phoneCode">
      <el-input v-model="form.phoneCode"
        style="width: 50%"
        placeholder="请输入您收到的短信验证码">
      </el-input>
      <el-button @click.prevent="sendCode"
        :loading="codeLoding"
        :disabled="!show"
        style="margin-left: 10px">
        <span v-show="show">获取短信验证码</span>
        <span v-show="!show"
          class="count">{{ count }} s</span>
      </el-button>
    </el-form-item>
    <el-form-item label="新密码"
      prop="pass">
      <el-input type="password"
        v-model="form.pass"
        autocomplete="off"
        placeholder="请输入新密码"
        style="width:50%"></el-input>
    </el-form-item>
    <el-form-item label="密码确认"
      prop="checkPass">
      <el-input type="password"
        v-model="form.checkPass"
        autocomplete="off"
        placeholder="请再次输入新密码"
        style="width:50%"></el-input>
    </el-form-item>
    <div style="text-align: right">
      <el-button @click="backEditPassword">返 回</el-button>
      <el-button type="primary"
        :loading="loadingBtn"
        @click="submitPassword('form')">确认修改</el-button>
    </div>
  </el-form>
</template>

<script>
import api from "@/api";
import {
  handleLoginErrorToast,
  handleLoginSuccessToast,
} from "@/assets/utils/handleData.js";
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.pass) {
        callback(new Error("您两次密码输入不一致，请重新输入!"));
      } else {
        callback();
      }
    };
    return {
      codeLoding: false,
      loadingBtn: false,
      form: {
        phoneCode: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          },
        ],
        pass: [
          { required: true, validator: validatePass, trigger: "blur" },
          {
            pattern: /\S/,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 8,
            max: 16,
            message: "请输入8-16位密码",
            trigger: "blur",
          },
          {
            pattern:
              /^(?!^\d+$)(?!^[a-z]+$)(?!^[A-Z]+$)(?!^[^a-z0-9]+$)(?!^[^A-Z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S*$/,
            message: "包含数字/字母/特殊字符至少两种",
            trigger: "blur",
          },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
      count: null,
      show: true,
      timer: null,
    };
  },
  methods: {
    sendCode() {
      if (this.userPhone === "-") {
        this.$message.error("未绑定手机号码,请联系管理员!");
        return;
      }
      this.codeLoding = true;
      this.sendCodeBySelf();
    },
    async sendCodeBySelf() {
      let res = await api.loginSendSMSCodeBySelf({});
      if (res && res.status == 200) {
        this.codeLoding = false;
        if (res.data.code == 200) {
          if (handleLoginSuccessToast(res.data.data) !== "") {
            this.$message.success("发送验证码成功");
            this.getCode();
          } else {
            this.$message.error(handleLoginErrorToast(res.data.data));
          }
        }
      }
    },
    getCode() {
      if (!this.timer) {
        this.count = 60;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    backEditPassword() {
      this.$parent.showCom = "editPassword";
    },
    submitPassword(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loadingBtn = true;
          let res = await api.loginModifyPasswordByPhone({
            password: this.form.checkPass,
            smsCode: this.form.phoneCode,
          });
          if (res && res.data.code == 200) {
            this.loadingBtn = false;
            this.$message.success("修改密码成功,请重新登录！");
            setTimeout(() => {
              this.$store.dispatch("logout");
              this.$store.commit("SET_ROUTE", []);
            }, 1000);
          } else {
            this.loadingBtn = false;
          }
        }
      });
    },
  },
  created() {
    this.userPhone =
      JSON.parse(window.sessionStorage.getItem("userInfo")).phone ?? "-";
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.resetPasswordForm {
  .project-title {
    color: #377afd;
    font-size: 48px;
    font-weight: bolder;
    margin-bottom: 60px;
  }
}
</style>